// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2-YFM","filesListContainer":"PosDisputesFiles_filesListContainer__PHbLn","filesButton":"PosDisputesFiles_filesButton__2UsKM"};